// 菜单
export default {
    dashboard: 'титульная страница',
    flight: 'Управление полетом',
    department: 'Управление отделом',
    user: 'Пользователь',
    userManage: 'Управление пользователями',
    userReview: 'Обзор пользователей',
    role: 'Управление ролями',
    group: 'Управление Групповое',
    log: 'Управление журналом',
    taskManage: 'Управление задачами',
    allTasks: 'Все задачи',
    myTask: 'мое задание',
    taskConfig: 'Конфигурация задачи',
    addTaskSpot: "Добавить точечная разведка",
    addTaskArea: "Добавить pегиональная разведка",
    addTaskOrthophoto: "Добавить положительное изображение",
    addTaskObliquePhotography: "Добавить перспективное фотографирование",
    addTaskLogistics: "Добавить логистический транспорт",

    editTaskSpot: "Pедактировать точечная разведка",
    editTaskArea: "Pедактировать pегиональная разведка",
    editTaskOrthophoto: "Pедактировать положительное изображение",
    editTaskObliquePhotography: "Pедактировать перспективное фотографирование",
    editTaskLogistics: "Pедактировать логистический транспорт",

    approval: 'Управление утверждением',
    autoApproval: 'автоматическое одобрение',
    noFlyZone: 'Управление бесполетной зоной',
    addNoFlyZone: 'Добавить бесполетную зону',
    editNoFlyZone: 'Изменить бесполетную зону',
    noFlyZoneLifted: 'Бесполетная зона снята',
    globalFence: 'Глобальный электронный забор',
    boundaryAlarm: 'Журнал аварийных сигналов',
    device: 'Управление оборудованием',
    newsPush: 'Новости push',
    corporateInformation: 'Корпоративная информация',

    // button
    query: 'Узнать',
    add: 'Добавить к',
    edit: 'редактировать',
    delete: 'удалять',
    personnel: 'Кадровый менеджмент',
    freezeRecovery: 'Заморозить/Восстановить',
    legalize: 'Сертификация',
    check: 'Проверять',
    submit: 'Разместить',
    release: 'выпускать',
    revoke: 'Отозвать',
    results: 'Отображение достижений',
    report: 'Создать отчет',
    recover: 'восстанавливаться',
    mapView: 'Просмотр карты',
    pass: 'пройти через',
    fail: 'Неудача',
    automaticApprovalSet: 'Настройки автоматического одобрения',
    validInvalid: 'действительный/недействительный',
    invalid: 'Недействительность',
    details: 'Подробности',
    permission: 'Pазрешение',
    addNews: 'Новое сообщение',
    upload: 'Загрузить',
}